import { Post } from "~/components/PostCard/types";
import type { Page } from "~/types";

const highlightNameHeadline = "headline-group";
const highlightNameCards = "card-list";
const highlightNameCardsAndHeadline = "headline-strapi-card-group";
const highlightNameWraplink = "wrap_link_list";
const highlightNameWraplinkAndHeadline = "headline-and-link-group";
const highlightNameCtaBanner = "cta-banner";

export function getSections<P extends Page>(page?: P) {
  const headlineGroupSections: unknown[] = [];
  const cardGroupSections: unknown[] = [];
  const headlineCardGroup: unknown[] = [];
  const ctaBannerList: unknown[] = [];
  const wraplinkList: unknown[] = [];
  const wraplinkListAndHeadlineGroup: unknown[] = [];

  const sections = page?.attributes?.sections?.reduce(
    (accSections, section) => {
      const sectionName =
        section.__component.match(/\.(?<sectionName>.*)$/)?.groups
          ?.sectionName ?? "";
      if (!sectionName) {
        return accSections;
      }

      if (sectionName === highlightNameHeadline) {
        headlineGroupSections.push(section);
      } else if (sectionName === highlightNameCards) {
        cardGroupSections.push(section);
      } else if (sectionName === highlightNameCardsAndHeadline) {
        headlineCardGroup.push(section);
      } else if (sectionName === highlightNameCtaBanner) {
        ctaBannerList.push(section);
      } else if (sectionName === highlightNameWraplink) {
        wraplinkList.push(section);
      } else if (sectionName === highlightNameWraplinkAndHeadline) {
        wraplinkListAndHeadlineGroup.push(section);
      }

      return {
        ...accSections,
        [sectionName]: Array.isArray(section)
          ? section[0]
          : sectionName === highlightNameHeadline
          ? headlineGroupSections
          : sectionName === highlightNameCards
          ? cardGroupSections
          : sectionName === highlightNameCardsAndHeadline
          ? headlineCardGroup
          : sectionName === highlightNameCtaBanner
          ? ctaBannerList
          : sectionName === highlightNameWraplink
          ? wraplinkList
          : sectionName === highlightNameWraplinkAndHeadline
          ? wraplinkListAndHeadlineGroup
          : section,
      };
    },
    {}
  );

  return sections ?? {};
}
